import React, {useState} from "react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";

const componentName="SearchUsers";

export const SearchUsers = ({ submitSearchPrameters, roles, accessTypes }) => {
  const [searchParameters, setSearchParameters] = useState({
    firstName: "",
    lastName: "",
    email: "",
    accessType: "",
    accessId: "",
    accessName: "",
    roleId: "",
  });
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchParameters({ ...searchParameters, [name]: value });
  };

  const handleSearchClick = (e) => {
    submitSearchPrameters(searchParameters);
  };
  const handleResetClick = (e) => {
    const searchParam = { firstName: "",
    lastName: "",
    email: "",
    accessType: "",
    accessId: "",
    accessName: "",
    roleId: ""}
    setSearchParameters({
      ...searchParameters,
      firstName: "",
      lastName: "",
      email: "",
      accessType: "",
      accessId: "",
      accessName: "",
      roleId: ""
    });
    submitSearchPrameters(searchParam)
  };

  roles.sort((a, b) => {
    if (a.name > b.name) return 1;
    if (a.name < b.name) return -1;
    return 0;
  });

  return (
    <Card className="mb-3">
      <Card.Body className="overflow-auto">
        <Row>
          <Col className="mb-3">
            <label id={`${componentName}-firstNameLabel`} className="d-block">First Name</label>
            <input
              type="text"
              name="firstName"
              id={`${componentName}-firstNameValue`}
              value={searchParameters.firstName}
              className="form-control text-capitalize"
              maxLength="50"
              onChange={(e) => handleSearchChange(e)}
            />
          </Col>
          <Col className="mb-3">
            <label id={`${componentName}-lastNameLabel`} className="d-block">Last Name</label>
            <input
              type="text"
              name="lastName"
              id={`${componentName}-lastNameValue`}
              value={searchParameters.lastName}
              className="form-control text-capitalize"
              maxLength="50"
              onChange={(e) => handleSearchChange(e)}
            />
          </Col>
          <Col className="mb-3">
            <label id={`${componentName}-emailLabel`} className="d-block">User ID or Email</label>
            <input
              type="email"
              name="email"
              id={`${componentName}-emailValue`}
              value={searchParameters.email}
              className="form-control"
              maxLength="100"
              onChange={(e) => handleSearchChange(e)}
            />
          </Col>
        </Row>
        <Row>
          <Col className="mb-3">
            <label id={`${componentName}-accessTypeLabel`} className="d-block">Access Type</label>
            <Form.Control
              disabled={!accessTypes.length}
              as="select"
              name="accessType"
              id={`${componentName}-accessTypeValue`}
              value={searchParameters.accessType}
              className="form-select"
              onChange={(e) => handleSearchChange(e)}
            >
              <option value="">-Select-</option>
              {accessTypes.map((access) => (
                <option key={access} value={access}>
                  {access}
                </option>
              ))}
            </Form.Control>
          </Col>
          <Col className="mb-3">
            <label id={`${componentName}-identifierLabel`} className="d-block">Identifier</label>
            <input
              type="text"
              name="accessId"
              id={`${componentName}-identifierValue`}
              value={searchParameters.accessId}
              className="form-control text-capitalize"
              onChange={(e) => handleSearchChange(e)}
            />
          </Col>
          <Col className="mb-3">
            <label id={`${componentName}-rolesLabel`} className="d-block">Role</label>
            <Form.Control
              disabled={!roles.length}
              as="select"
              name="roleId"
              id={`${componentName}-rolesValue`}
              value={searchParameters.roleId}
              className="form-select"
              onChange={(e) => handleSearchChange(e)}
            >
              <option value="">-Select-</option>
              {roles.map((role, idx) => (
                <option key={role.id || role.value || `${role.name}-${idx}`} value={role.id}>
                  {role.name}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Row>
        <Row className="text-end">
          <Col>
            <Button
              id={`${componentName}-resetButton`}
              variant="secondary"
              onClick={() => handleResetClick()}
              className="me-2"
            >
              Reset
            </Button>
            <Button
              id={`${componentName}-searchButton`}
              variant="primary"
              onClick={() => handleSearchClick()}
            >
              Search
            </Button>
          </Col>
        </Row>        
      </Card.Body>
    </Card>
  );
};

export default SearchUsers;
